export const CONTAINER_TEST_ID = 'search-bar-container';
export const INPUT_CONTAINER_TEST_ID = 'search-bar-input-container';
export const INPUT_TEST_ID = 'search-bar-input';
export const CLEAR_ICON_TEST_ID = 'search-bar-clear-icon';
